import Home from "@/components/Home.vue";
import LoginError from "@/views/loginError.vue";
import NotFound from "@/views/notFound.vue";
import Login from "@/views/UserLogin.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { requiresAuth: true },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { requiresAuth: false },
  },
  {
    path: "/login-error",
    name: "LoginError",
    component: LoginError,
    meta: { requiresAuth: false },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
    meta: { requiresAuth: false },
  },
];

export default routes;
